import SchoolProfileInformation from './SchoolProfileInformation.component';

export default SchoolProfileInformation;